import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";

import { store } from "./store";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

import "./styles/themes.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: {
              background: "var(--color-card-bg)",
              color: "var(--color-text-primary)",
              border: "1px solid var(--color-card-border)",
            },
          }}
        />
      </Provider>
    </ErrorBoundary>
);
